<template>
  <div>
    <template v-if="envelopeTemplateDrafts.length === 0">
      <AppAlertInPage variant="error">
        <span class="text-text-secondary">{{ $t('project.signing-checklist.envelope-templates.add.EnvelopeTemplateAddSettings.noValidFilesAlert') }}</span>
      </AppAlertInPage>
    </template>
    <template v-else>
      <p v-if="formMode === 'creation'" class="text-text-primary text--large text--bold">
        {{ $t('project.signing-checklist.envelope-templates.add.EnvelopeTemplateAddSettings.titleCreation') }}
      </p>
      <p v-else class="text-text-primary text--large text--bold">
        {{ $t('project.signing-checklist.envelope-templates.add.EnvelopeTemplateAddSettings.titleEdition') }}
      </p>

      <p class="text-text-secondary mb-3 text--small">
        {{ $t('project.signing-checklist.envelope-templates.add.EnvelopeTemplateAddSettings.subTitle') }}
      </p>

      <v-expansion-panels>
        <EnvelopeTemplateAddSettingsDocument
          v-for="({ document }) in envelopeTemplateDrafts"
          :key="document.id"
          :file="document"
          @signatureTypeChange="onSignatureTypeChange"
        />
      </v-expansion-panels>
    </template>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { mapState } from 'vuex'

import { toast } from '@/common/utils/toast'
import AppAlertInPage from '@/design-system/alert/AppAlertInPage.vue'
import EnvelopeTemplateAddSettingsDocument from '@/project/signing-checklist/envelope-templates/add/EnvelopeTemplateAddSettingsDocument.vue'

export default defineComponent({
  name: 'EnvelopeTemplateAddSettings',
  props: {
    formMode: {
      type: String,
      default: 'creation',
    },
  },
  computed: {
    ...mapState('envelopeTemplates', ['envelopeTemplateDrafts']),
    ...mapState('room', ['currentRoom']),
  },
  head () {
    return {
      title: this.$t('project.documents.Documents.metaTitle'),
    }
  },
  components: { AppAlertInPage, EnvelopeTemplateAddSettingsDocument },
  methods: {
    onSignatureTypeChange (originalFile, signatureType) {
      if (
        this.envelopeTemplateDrafts.length > 1 &&
        this.envelopeTemplateDrafts.every(
          (templateDraft) => templateDraft.document.objectToPost.signatureType === '' || templateDraft.document === originalFile,
        )
      ) {
        let updatedSomethingElse = false

        for (const templateDraft of this.envelopeTemplateDrafts) {
          if (templateDraft.document === originalFile) {
            continue
          }
          const provider = signatureType.split('.')[0]
          const maxSize = this.currentRoom.providers.find((roomProvider) => roomProvider.provider === provider).maxSize
          if (maxSize > templateDraft.document.size) {
            templateDraft.document.objectToPost.signatureType = signatureType
            updatedSomethingElse = true
          }
        }
        if (updatedSomethingElse) {
          toast.success(this.$t('project.signing-checklist.envelope-templates.add.EnvelopeTemplateAddSettings.groupSignatureTypeChange'))
        }
      }
    },
  },
})
</script>
